import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { ClipLoader } from "react-spinners";
import loader from "../assets/Loading.lottie";
import { createPortal } from 'react-dom';

export function Loading({ className, traditional }) {
  return createPortal(
    <div className="flex justify-center items-center fixed top-0 left-0 w-screen h-screen">
      {
        traditional
          ? <ClipLoader />
          : <DotLottieReact className={`w-80 ${className}`} src={loader} autoplay loop />
      }
    </div>,
    document.body
  )
}
